var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBox(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 110,
    viewBox: "0 0 105 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3036 58.5745L52.3521 11.6343L12.1113 34.8828L52.3036 58.5745Z",
    fill: "#5D54D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4784 0L52.3516 11.6344L92.6206 34.8828L104.949 23.1793L64.4784 0Z",
    fill: "#5D54D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3047 58.5745V110L64.7791 102.741L64.577 102.827L52.3047 58.5745Z",
    fill: "#574ED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6781 70.0381L52.3047 58.5745L64.577 102.827L64.7791 102.741L92.7071 86.5198V53.6865L64.6781 70.0381Z",
    fill: "#4136CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6222 34.8828C70.0381 48.1479 75.2769 45.0817 52.3047 58.5745L64.6781 70.0381L105 46.4033L92.6222 34.8828Z",
    fill: "#5D54D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2205 0L52.3514 11.6344L12.1106 34.8828L0 23.1793L40.2205 0Z",
    fill: "#9F9AE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4244 70.038L11.8779 53.3448V86.5197L52.3046 110V58.5744L40.4244 70.038Z",
    fill: "#6E65ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1106 34.8828L0 46.4033L40.4226 70.0381L52.3028 58.5745L12.1106 34.8828Z",
    fill: "#9F9AE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3047 58.5745L52.3532 11.6343L92.6222 34.8828L52.3047 58.5745Z",
    fill: "#352BBE"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBox);
export default __webpack_public_path__ + "static/media/ic-box.fb845339239a2f61e1a677bdb40942a6.svg";
export { ForwardRef as ReactComponent };